<ng-template #step1>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.VlanLightpath.Subheading" | translate }}</h3>
      <p class="no-margin">{{ "Selfservice.VlanLightpath.Text" | translate }}</p>
    </div>
    @for (item of endpoints(); track $index) {
      <div class="selfservice-add-port__bar selfservice-add-port__bar--col">
        <div class="selfservice-add-port__bar-flex">
          <div class="selfservice-add-port__left">
            <div class="selfservice-add-port__details active">
              <div class="selfservice-add-port__icon-box">
                <svg-icon src="assets/images/icons/port.svg"></svg-icon>
              </div>
              <div>
                <h3>{{ item.port.customerDescription }}</h3>
                <div class="selfservice-add-port__meta">
                  {{ item.port.subscriptionId | shorten_guid }} - {{ item.organisation }},
                  {{ item.port.address?.city }} ({{ item.port.address?.street }})
                </div>
              </div>
            </div>
            @if (isMyPort(item.port)) {
              <div class="selfservice-add-port__left-bottom">
                <div>{{ "Selfservice.AddPort.NotAvailableVlans" | translate }}</div>
                <ul class="selfservice-add-port__tags">
                  @for (v of item.port.usedVlans; track v) {
                    <li>{{ v }}</li>
                  }
                </ul>
              </div>
            }
          </div>
          <div class="selfservice-add-port__right">
            <div class="selfservice-add-port__form">
              <label>{{ "Selfservice.AddPort.CurrentVlan" | translate }}</label>
              <div>{{ item.vlanrange }}</div>
            </div>
            @if (isMyPort(item.port)) {
              <div class="selfservice-add-port__form">
                <label>{{ "Selfservice.AddPort.NewVlan" | translate }}</label>
                <input
                  type="string"
                  [(ngModel)]="item.vlan"
                  [class.error]="item.vlan && !validVlan(item.port, item.vlan, item.vlanrange)"
                />
              </div>
            }
            @if (item.vlan && !validVlan(item.port, item.vlan, item.vlanrange)) {
              <div class="red" style="font-size: 12px">
                {{ "Selfservice.AddPort.VlanInUse" | translate }}
                <br />
                <br />
              </div>
            }
            @if (isMyPort(item.port)) {
              <p class="selfservice-add-port__footnote">
                {{ "Selfservice.AddPort.VlanHint" | translate }}
              </p>
            }
          </div>
        </div>
        @if (!isMyPort(item.port)) {
          <div class="service__unavailable-bar">
            <span class="service__unavailable-bar-side">
              <svg-icon class="service__unavailable-bar-icon" src="assets/images/icons/lock.svg"></svg-icon>
            </span>
            <span class="service__unavailable-bar-text">
              <strong>{{ "Global.NoAccess" | translate }}</strong> {{ "Global.PleaseContact" | translate }}
              {{ item.organisation }}
            </span>
            <span class="service__unavailable-bar-side"></span>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #step2>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Global.Summary" | translate }}</h3>
      <p class="no-margin t-newline">{{ "Selfservice.VlanLightpath.SummaryText" | translate }}</p>
    </div>
    <div class="dialog__port-summary">
      @for (endpoint of endpoints(); track $index) {
        <div class="dialog__port-summary-item">
          <div class="dialog__port-summary-left dialog__port-summary-left--center">
            <svg-icon class="dialog__port-icon" src="assets/images/icons/port.svg"></svg-icon>
            <div class="dialog__port-text">{{ endpoint.port.customerDescription }}</div>
          </div>
          <div class="dialog__port-summary-right">
            <div>VLAN {{ endpoint.vlanrange }}</div>
            @if (endpoint.vlan) {
              <div class="dialog__port-summary-right-flex">
                <svg-icon src="assets/images/icons/arrow-long.svg"></svg-icon>
                <span class="blue">VLAN {{ endpoint.vlan }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="dialog__bottom-message">
    <div class="dialog__bottom-message-inner">
      <svg-icon src="assets/images/icons/status-failure.svg" class="dialog__bottom-message-icon"></svg-icon>
      <span>{{ "Selfservice.VlanLightpath.Message" | translate }} </span>
    </div>
  </div>
</ng-template>

<selfservice-wizard [steps]="[step1, step2]" [getCommand]="buildCommand" [bus]="bus()" [canContinue]="vlanMatches()" />
